import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.tsx';

const container = document.querySelector('#root');
if (!container) {
  throw new Error('missing #root container');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
